export { BrowserTracing } from './browsertracing';
export { instrumentOutgoingRequests, defaultRequestInstrumentationOptions, } from './request';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sentry/tracing/esm/browser/index.js
// module id = 224
// module chunks = 140